import { useProjectSharedState } from "./useSharedState";
import { CSVService } from "Apis";
import { ApiCSVUploadSession, ApiProject } from "@incendium/api";

export const useCSVSessions = () => {
  const fetchCSVSessions = async (project: ApiProject) => {
    const CSVSessions = await CSVService.cSVServiceListCSVSessions({
      projectId: project.id as number,
    });
    return CSVSessions.sessions || [];
  };

  const { state, setState, refetch } = useProjectSharedState(
    "CSVSessions",
    [],
    fetchCSVSessions
  );

  return {
    CSVSessions: state as ApiCSVUploadSession[],
    setCSVSessions: setState,
    refetchCSVSessions: refetch,
  };
};
